import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import CurrencyInput from "../CurrencyInput/CurrencyInput";
import Switch from "../Switch/Switch";
import NumberSpinner from "../NumberSpinner/NumberSpinner";
import { format, parseISO } from 'date-fns';
import numeral from "numeral";

export default class DailyRateBuilder extends React.Component {

	constructor(props) {
		super(props);

		var self = this;

		this.state = {
			amount: this.props.amount,
			minimum_stay: this.props.minimum_stay,
			blackout: this.props.blackout,
	    loading: false,
		};

		this.onChange = this.onChange.bind(this);
		this.onChangeBlackout = this.onChangeBlackout.bind(this);
		this.onSave = this.onSave.bind(this);
	}

	render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          // e.stopPropagation();
          // e.preventDefault();
          self.onSave();
          // return false;
        },
      },
    ]

		return (
			<div className="RatesDashboardRoomTypeRateDateOverrides">
				{this.renderErrors()}
				<div className="daily-room-type-price-row-form">
					<div className="row">
						<div className="col-sm-3">
							<div className="form-group">
								<label>{I18n.t('amount')}</label>
							  <div className="input-group input-group-currency" style={{marginLeft: 0}}>
							    {/* <div className="input-group-addon">{I18n.t('number.currency.format.unit')}</div> */}
							    <CurrencyInput className={this.renderFieldClasses('amount')} value={this.state.amount} name="amount" onChange={this.onChange} onChangeEventType={true} nested={true} />
							  </div>
								{this.renderFieldErrors('amount')}

							  <div className="default-value-helper-text">
							  	<em>{this.props.base_amount ? <span>{I18n.t('number.currency.format.unit')}{numeral(this.props.base_amount / 100).format('0,000.00')}</span> : I18n.t('none')}</em>

							  </div>
							</div>
						</div>
						<div className="col-sm-3">
							<div className="form-group">
								<label>{I18n.t('min_stay')}</label>
							  <NumberSpinner name="minimum_stay" value={this.state.minimum_stay} onChange={this.onChange} />
							  <div className="default-value-helper-text"><em>{this.props.minimum_stay || I18n.t('none')}</em></div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-sm-6">
							<div className="form-group">
								<label>{I18n.t('blackout')} <span className="ss-help help" title={I18n.t('blackout_helper_text')}></span></label>
								<Switch onText="enabled" offText="disabled" onChange={this.onChangeBlackout} value={this.state.blackout} switchId="blackout-switch" />
							</div>
						</div>
					</div>
					<ModalButtons loading={this.state.loading} buttons={buttons} />
					<LoadingSpinner show={this.state.loading} />
				</div>
			</div>
		);
	}

	/**
	* Change handlers
	*/

	onChange(event) {

		if (event && event.target && event.target.name && typeof event.target.value != 'undefined') {
			var newState = {};
			if (event.target.name == "amount" || event.target.name == "minimum_stay") {
				if (event.target.value != null && event.target.value > 0) {
					newState[event.target.name] = event.target.value;
					this.setState(newState);
				}
			} else {
				newState[event.target.name] = event.target.value;
				this.setState(newState);

			}
		}
	}

	onChangeBlackout(event) {
		this.setState({blackout: event.target.checked});

	}

	onSave(event) {
		var self = this;

		if (event && event.stopPropagation && event.preventDefault) {
			event.stopPropagation();
			event.preventDefault();
		}

		this.setState({loading: true});

    $.ajax({
      type: this.props.new_record ? 'POST' : 'PUT',
      url: this.props.form_action,
      data: {
        daily_rate: {
          blackout: this.state.blackout,
          date: format(parseISO(this.props.date), 'yyyy-MM-dd'),
          amount: this.state.amount,
          minimum_stay: this.state.minimum_stay,
          room_type_id: this.props.room_type_id,
          rate_id: this.props.rate_id,
					updated_at: this.props.updated_at
        }
      }
    }).done((data) => {
      // $(window.parent).trigger('dailyRateSaved', data)


			if (data && data.errors && Object.keys(data.errors).length) {
				this.setState({loading: false, errors: data.errors})
			} else {
				this.setState({loading: false})

				if (parent && parent.refresh_data) {
					parent.refresh_data(I18n.t('daily_rate_saved_successfully'))
				}

				if (parent && parent.hide_modal) {
					parent.hide_modal()
				}

			}

    });
	}

	renderFieldClasses(field) {
		var classname = 'form-control'
		if (this.state.errors && Object.keys(this.state.errors).length && this.state.errors[field]) {
			classname = classname + ' has-errors'
		}
		return classname
	}

	renderFieldErrors(field) {
		if (this.state.errors && this.state.errors[field]) {
			var idx = 0
			var errors = this.state.errors[field].map((error) => {
				idx = idx + 1
				return <li key={idx}><b>&#x2022;</b> {error}</li>
			})
			return (
				<div className="help-block">
					<ul>{errors}</ul>
				</div>
			)
		}
	}

	renderErrors() {

		if (this.state.errors && this.state.errors.amount) {
			// "Here"
			// var errors = this.state.errors.amount.map((error) => {
			// 	return <li key={error}>{error}</li>
			// })

			return(
				<div className="alert alert-danger">
					<ul><li>{I18n.t("amount_can't_be_blank")}</li></ul>
				</div>
			)
		}
	}

}
